import BasePage from "./BasePage";

export default class LiabilityDischargePage extends BasePage {
    
    public static async init() {
        await super.init();

        $(".print").on("click", function () { window.print(); });
    }
}